var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelegation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3H17.73C17.1 1.26 15.45 0 13.5 0C11.55 0 9.9 1.26 9.27 3H3C1.35 3 0 4.35 0 6V27C0 28.65 1.35 30 3 30H24C25.65 30 27 28.65 27 27V6C27 4.35 25.65 3 24 3ZM13.5 3C14.325 3 15 3.675 15 4.5C15 5.325 14.325 6 13.5 6C12.675 6 12 5.325 12 4.5C12 3.675 12.675 3 13.5 3ZM13.5 9C15.99 9 18 11.01 18 13.5C18 15.99 15.99 18 13.5 18C11.01 18 9 15.99 9 13.5C9 11.01 11.01 9 13.5 9ZM22.5 27H4.5V24.9C4.5 21.9 10.5 20.25 13.5 20.25C16.5 20.25 22.5 21.9 22.5 24.9V27Z",
    fill: "#0A3575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegation);
export default __webpack_public_path__ + "static/media/delegation.72fbcdb63408710b022e8b46e4317087.svg";
export { ForwardRef as ReactComponent };